import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";

import Index from "./pages/Index";
import Privacy from "./pages/Privacy";
import ThankYou from "./components/ThankYou";
import Header from "./components/Header"; // ✅ fixed import (capital H, relative path)

const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => {
  console.log("🚀 App component loaded");
  console.log("🚀 Current pathname:", window.location.pathname);

  // ✅ Wrap Privacy with the global header so it has the same top nav
  const PrivacyWithHeader = () => {
    console.log("🚀 Privacy route matched! URL:", window.location.pathname);
    return (
      <>
        <Header />
        {/* Push content below fixed header */}
        <main className="pt-20">
          <Privacy />
        </main>
      </>
    );
  };

  const TestRoute = () => {
    console.log("🧪 Test route working!");
    return (
      <div style={{ color: "white", padding: "20px" }}>
        Test Route Works!
      </div>
    );
  };

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            {/* Index already includes its own header; leave as-is */}
            <Route path="/" element={<Index />} />

            <Route path="/test" element={<TestRoute />} />

            {/* ✅ Privacy now uses the same top navigation */}
            <Route path="/privacy" element={<PrivacyWithHeader />} />

            {/* ThankYou can stay as-is; add a header later if you want */}
            <Route path="/thank-you" element={<ThankYou />} />

            <Route
              path="*"
              element={
                <Suspense fallback={<div className="min-h-screen bg-background" />}>
                  <NotFound />
                </Suspense>
              }
            />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
